
import { Component, Vue, Prop } from 'vue-property-decorator';
import depositService from '@/services/deposit-services';
import { DepositModel } from '@/models/deposit'
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class DepositDetailFooter extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;
    
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }
    private async complainOrder() {
        this.$router.push({ name: 'deposit-complain', params: { orderId: this.deposit.id.toString(), orderType: '2' } });
    }
    private async cancelOrder() {
        const dataRequest =  {
            Status: 1
        };
        const result = await depositService.updateDeposit(this.deposit.id, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });
            this.$emit('eventCancelOrder', { status: 1 });
        }
    }
}
